import { render } from "./PrivateBookingList.vue?vue&type=template&id=7b945e20&scoped=true"
import script from "./PrivateBookingList.vue?vue&type=script&lang=js"
export * from "./PrivateBookingList.vue?vue&type=script&lang=js"

import "./PrivateBookingList.vue?vue&type=style&index=0&id=7b945e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b945e20"]])

export default __exports__